import ME from "../../assets/me-about.jpg";
import { FaAward } from "react-icons/fa";
import { IoLibraryOutline } from "react-icons/io5";
import "./About.css";

export default function About() {
  return (
    <section id="about">
      <h5>Introduction</h5>
      <h2>About me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="Trai Torti" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Focus</h5>
              <small>Backend · Pipeline TD · Python · Django · AWS</small>
            </article>
            <article className="about__card">
              <IoLibraryOutline className="about__icon" />
              <h5>Education</h5>
              <small>Master of AI (QUT, 2026) · B.IT Comp Sci</small>
            </article>
          </div>

          <p>
            I&apos;m Trai, a <strong>backend software engineer</strong> based on the{" "}
            <strong>Gold Coast, Queensland</strong>. I build and operate production
            systems in <strong>Python</strong> and <strong>Django</strong> on{" "}
            <strong>AWS (EC2)</strong> with <strong>Docker</strong> and{" "}
            <strong>GitHub Actions</strong> CI/CD — designing secure REST APIs,
            tuning <strong>PostgreSQL</strong>, and improving reliability through
            testing and automation.
          </p>
          <p>
            I also have deep <strong>pipeline technical direction</strong> experience
            from <strong>PROXI VP</strong>, where I led 40+ Python automation tools for
            VFX/production workflows. Recent roles include backend services at{" "}
            <strong>RepliAi</strong> and freelance full-stack delivery. I&apos;m
            completing a <strong>Master of Artificial Intelligence at QUT</strong> —
            open to backend engineering as well as pipeline TD roles in film, TV, and
            games. Study abroad in China and Korea supports bilingual collaboration.
          </p>

          <div className="about__cta">
            <a href="#work" className="btn">
              See my work
            </a>
            <a href="#contact" className="btn btn-primary">
              Get in touch
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
